import styled from '@emotion/styled';

export const UnitWrapper = styled.span`
  margin-left: ${(props) => props.theme.spacing(0.5)};
  color: ${(props) => props.theme.palette.primary.main};
  font-size: 0.8em;
`;
